import { useSuspenseQuery } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";

import Loading from "@/components/loadings/Loading";

import MeetSession from "../../components/flows/MeetSession";
import { useGuestToken } from "../../hooks/useGuestToken";
import { fetchMeetRoomQueryOptions } from "../../services";

export const Route = createFileRoute("/_meet/meet/$code")({
  component: Component,
  pendingComponent: () => (
    <div className="flex h-screen items-center justify-center">
      <Loading />
    </div>
  ),
});

function Component() {
  const { code } = Route.useParams();
  const { guestToken } = useGuestToken(code);
  const { data: room } = useSuspenseQuery(
    fetchMeetRoomQueryOptions(code, guestToken || undefined),
  );

  return <MeetSession code={code} room={room} />;
}
